import { Injectable } from '@angular/core';
import {
    IAssetMainService,
    IAssetTitles,
    IAssetType,
    IGenerateAssetFunctionParams,
} from '../assets-main/assets-main-manager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IAssetCollectionService } from 'src/app/components/shared/major/photos-collection/photos-list/photo-list-model';
import { UPLOADER_SERVICE_UNIQUE_IDS_ENUM } from 'src/app/constants/shared/uploader-service-unique-ids';
import { IUpdateTakeImage } from 'src/app/services/http-models/project/take/take-http-request-model';
import { ICallbacksForPickAsset } from '../../project/shared-components/pick-new-asset-state-manager.base';
import { UnsplashManagerService } from '../../../../../components/shared/major/photos-collection/unsplash-collection/unsplash-manager.service';
import { AssetUtilsService } from '../../../../../services/shared/utils/asset-utils.service';
import { WorkspaceAssetActionService } from '../../../../../services/workspace/actions/workspace-asset-action.service';
import { catchErrorTypedAsync } from '../../../../../services/functions-helper.service';
import { IGenerateVideoRequest } from '../../../../../services/http-models/asset/asset-http-request-model';
import { WorkspaceAssetStateManagerService } from '../../../../../services/workspace/state-management/associations/workspace-asset-state-manager.service';
import { ILocalAsset } from '../../../../../models/assets/assets.model';
import { FeatureService } from '../../../../../services/feature-service.service';

@Injectable()
export class AssetsLibraryServiceService implements IAssetMainService {
    photoService: IAssetCollectionService;
    asset: IAssetType = 'all';
    toDisplaySelectAsset = false;
    toDisplayExitButton: boolean = false;
    isUploading = false;
    isHosted = true;
    toDisplayLoading = true;
    currentFolderName$ = this.wsAssetState.currentFolderName$;
    generatedVideo$ = this.wsAssetState.onGeneratedVideo$;
    displayTitles: IAssetTitles = {
        library: false,
        generate: true,
        upload: false,
        generateVideo: true,
        videoLibrary: false,
    };
    toDisplayHeader: boolean = true;
    initialGenerateImagePrompt: string = null;
    type: UPLOADER_SERVICE_UNIQUE_IDS_ENUM = UPLOADER_SERVICE_UNIQUE_IDS_ENUM.ASSET_LIBRARY;
    toMakeUploadAsMainButton = true;
    toEnableImageToVideo = true;
    toEnableEditImage = true;
    toDisplayExtendVideoOption = true;
    toDisplayIncludeLogoOption = true;
    constructor(
        private unsplashService: UnsplashManagerService,
        private assetUtilsService: AssetUtilsService,
        private wsAssetActionService: WorkspaceAssetActionService,
        private wsAssetState: WorkspaceAssetStateManagerService,
        private unleashService: FeatureService
    ) {
        this.photoService = this.unsplashService;
    }

    async setFeatureAccessForGenerateAsync() {
        this.toDisplayExtendVideoOption = await this.unleashService.getFeatureAccessValue('display_extend_video');
        this.toDisplayIncludeLogoOption = await this.unleashService.getFeatureAccessValue(
            'display_include_logo_in_generate_image'
        );
    }

    async createNewAssetAsync(updateImage: IUpdateTakeImage) {
        if (!updateImage?.pickImageFromUnsplash || updateImage.pickAsset || updateImage.generateImage) {
            return;
        }
        const { photoId } = updateImage.pickImageFromUnsplash;
        const uploadTo = this.wsAssetState.getCurrentFolderName();
        const { data, error } = await catchErrorTypedAsync(
            this.assetUtilsService.uploadPhotoFromPhotoLibraryAsync(
                {
                    from: 'unsplash',
                    imageId: photoId,
                },
                uploadTo
            )
        );
        return !!data;
    }

    public async generateAssetAsync(generateAssetParams: IGenerateAssetFunctionParams) {
        const folderId = this._getCurrentFolderId();
        return await this.assetUtilsService.generateAssetLogic(generateAssetParams, folderId);
    }

    public async generateVideoAsync(data: IGenerateVideoRequest) {
        data.folderId = this._getCurrentFolderId();
        return await this.assetUtilsService.generateVideoAsync(data);
    }

    private _getCurrentFolderId(): string | null {
        const currentFolderName = this.wsAssetState.getCurrentFolderName();
        if (!currentFolderName) return null;

        const folders = this.wsAssetState.getCurrentFolders();
        return folders?.find((f) => f.folder === currentFolderName)?._id ?? null;
    }

    async onFileDrop(formData: FormData): Promise<{ data: any; error: Error | HttpErrorResponse }> {
        return await this.handleFileUploadedAsync(formData);
    }
    async uploadImageFromGenerateImage(formData: FormData) {
        return await this.handleFileUploadedAsync(formData);
    }

    selectImageFromAssetLibraryInGenerateImage(asset: ILocalAsset) {
        return null;
    }
    private async handleFileUploadedAsync(formData: FormData) {
        this.isUploading = true;
        try {
            const result = await this.wsAssetActionService.uploadAssetAsync(
                formData,
                this.wsAssetState.getCurrentFolderName()
            );

            // Refresh the gallery so freshly uploaded assets appear immediately
            this.wsAssetState.loadAssetsAsync();

            return { data: result, error: null };
        } catch (error) {
            return { data: null, error };
        } finally {
            this.isUploading = false;
        }
    }

    callbacks: ICallbacksForPickAsset = {
        onAssetChosen: () => () => {},
        onFileUploaded: () => () => {},
        onCloseButtonClicked: () => {},
        useBackArrowWhenImageSelected: true,
    };

    onCloseButtonClicked() {}

    setCurrentFolder(folderName: string | null) {
        if (folderName && folderName !== '/') {
            this.wsAssetState.enterFolder(folderName);
        } else {
            this.wsAssetState.exitFolder();
        }
    }
}
